import { useCallback, useEffect, useRef } from 'react';
import { debounce } from 'lodash';

export const useDebounce = (callback: Function, delay: number): Function => {
  const callbackRef = useRef<Function>(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce((...args) => callbackRef.current(...args), delay),
    [],
  );
};
